import styled from 'styled-components';

export const DialogBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
